module.exports = __webpack_public_path__ + "static/step-1-img-62629fd4e5feb386eebcf8f7763b44a7.png";